<!-- custom-workshop-calendar.component.html -->
<div class="input-group">
  <input
    class="form-control"
    name="workshopCalendar"
    ngbDatepicker
    #workshopDatePicker="ngbDatepicker"
    [dayTemplate]="customDay"
    [placement]="'bottom'"
    container="body"
    autoClose="false"
    (dateSelect)="onDateSelect($event)"
    (navigate)="navigateCalendar($event)"
    [markDisabled]="isDisabled"
    [startDate]="goToMonth()"
    style="padding: 0px; border-width: 0px; margin: 0px; width: 0; overflow: hidden"
  />
  <div class="input-group-append">
    <button 
      class="{{ class }} btn btn-secondary" 
      (click)="workshopDatePicker.open()" 
      (click)="streamOpened($event)" 
      type="button">
    </button>
  </div>
</div>

<ng-template #customDay let-date="date" let-currentMonth="currentMonth" let-selected="selected" let-disabled="disabled">
  <div
    id="calendarDayParent{{ date.day }}{{ date.month }}{{ date.year }}"
    *ngIf="date.month === currentMonth"
    style="width: 50px; margin-left: -10px"
  >
    <div
      class="customCss"
      [class.hidden]="date.month !== currentMonth"
      id="calendarDayChild00{{ date.day }}{{ date.month }}{{ date.year }}"
      data-toggle="tooltip"
      data-placement="top"
      title=""
    >
      {{ date.day }}
    </div>
    <div id="calendarValue{{ date.day }}{{ date.month }}{{ date.year }}" style="justify-content: center; font-size: x-small"></div>
  </div>
</ng-template>